import { cssDoTema, marca } from '@entregas/theme';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Provedores } from './app/Provedores';
import { roteador } from './app/rotas';
import { configPronta } from './config';
import { aplicarPreferenciaTema, lerPreferenciaTema } from './lib/preferenciaTema';
import './estilos.css';

// Tokens do tema viram variáveis CSS antes do primeiro render (sem piscar a cor errada).
const estilo = document.createElement('style');
estilo.dataset.tema = 'tokens';
estilo.textContent = cssDoTema();
document.head.prepend(estilo);
document.title = marca.nome;
aplicarPreferenciaTema(lerPreferenciaTema(), false);

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento #raiz não encontrado em index.html.');

createRoot(raiz).render(
  <StrictMode>
    {configPronta ? (
      <Provedores>
        <RouterProvider router={roteador} />
      </Provedores>
    ) : (
      <main style={{ maxWidth: 560, margin: '64px auto', padding: 16 }}>
        <h1>Configuração ausente</h1>
        <p>
          Defina VITE_SUPABASE_URL e VITE_SUPABASE_CHAVE_ANON em apps/web/.env.local (veja o
          .env.example).
        </p>
      </main>
    )}
  </StrictMode>,
);
